import React, { useEffect, useState, useRef} from 'react';
import { Page, Document, Image, StyleSheet, View } from '@react-pdf/renderer';
import InvoiceTitle from './InvoiceTitle'
import CompanyAddress from './CompanyAddress'
import DocumentItemsTable from './DocumentItemsTable'
import InvoiceNo from './InvoiceNo'
import InvoiceItemsTable from './DocumentItemsTable'
import InvoiceThankYouMsg from './InvoiceThankYouMsg'
import logo from '../../img/logo_eRobot_web.jpg'
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';
import * as moment from 'moment';
import 'moment/locale/sk';

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 11,
        paddingTop: 30,
        paddingLeft:60,
        paddingRight:60,
        lineHeight: 1.5,
        flexDirection: 'column',
    }, 
    logo: {
       // width: 74,
       // height: 66,
        //flexDirection: 'row',
        //marginLeft: 'auto',
        marginRight: '40px',
        //display: 'flex',
      //  justifyContent: 'right'
    },
    viewBox: {
        fontSize: 20,
        display: 'flex',
        alignItems: 'flex-start',
        border:'1px solid #000',
        flexDirection: 'row',
        marginTop: '0px',
        marginLeft: '40px',
        marginRight: '40px',
        marginBootom: '10px',
      
      },
      viewBox2: {
        fontSize: 20,
        display: 'flex',
        alignItems: 'flex-start',
        border:'3px solid #000',
        flexDirection: 'row'        
      },
  });
  
  const DocumentPrintTemplate1  = (props) => {

        const [t] = useTranslation();     
        const {i18n} = useTranslation();

        const [document, setDocument] = useState({transactionType: ''});     
        const [addressRight, setAddressRight] = useState(null);
        const [addressLeft, setAddressLeft] = useState(null);
       
        const [warehouseIss, setWarehouseIss] = useState(null);
        const [warehouseRct, setWarehouseRct] = useState(null);
        const [actionDate, setActionDate] = useState(null);
        const [documentTitle, setDocumentTitle]  = useState('Title');
   

        const [companyAddress, setCompanyAddress] = useState(null);     

        const [partnerAddress, setPartnerAddress] = useState(null); 

        moment.locale(i18n.language);
     
        useEffect(() => { 
          if(props.document!=null && props.document!== undefined){
            setDocument(props.document);
          }
        }, [props.document])

        useEffect(() => { 


            setCompanyAddress({
              // header: t('partner.label.supplier'),
               companyName: document.companyName,
               companyAddressLine1: document.companyAddressLine1,
               companyAddressLine1: document.companyAddressLine2,
               companyBusinessId: document.companyBusinessId,
               companyTaxId: document.companyTaxId,
               companyVatNo: document.companyVatNo,
   
           })

           setPartnerAddress({companyName: document.partnerName,
            companyAddressLine1: document.partnerAddressLine1,
            companyAddressLine1: document.partnerAddressLine2,
            companyBusinessId: document.partnerBusinessId,
            companyTaxId: document.partnerTaxId,
            companyVatNo: document.partnerVatNo,
           })
           
        
    
           
           let warehouseIssId=''
           let warehouseRctId=''           
//document!=null && document.transactionType!=null ? document.transactionType : null
           setDocumentTitle(t('document.label.'+ document.transactionType))

           switch(document.transactionType){
              case "RCT-PO":  
                warehouseRctId = document.warehouseRctId
              break;
              case "ISS-SO":   
               warehouseIssId = document.warehouseIssId
              break;
              case "ISS-WO":  
               warehouseIssId = document.warehouseIssId
              break;
              case "RCT-WO":   
                warehouseRctId = document.warehouseRctId
              break;
              case "ISS-TR":   
                warehouseIssId = document.warehouseIssId
                warehouseRctId =document.warehouseRctId
              break;
           }

           RestService.callAnyApi('warehouse/getWarehouse?id='+warehouseIssId, null)
           .then((data) => {          
               setWarehouseIss(data);    
               
           })
           .catch((error) => {
             console.log(error);
           });


           RestService.callAnyApi('warehouse/getWarehouse?id='+warehouseRctId, null)
           .then((data) => {          
               setWarehouseRct(data);    
               
           })
           .catch((error) => {
             console.log(error);
           });
      
       
        }, [document])
       


          useEffect(() => { 


           
            switch(document.transactionType){
              case "ISS-WO":
                
                setAddressRight({...companyAddress,header: t('partner.label.supplier')});                
                setAddressLeft({...companyAddress,header: t('partner.label.customer')});
                setActionDate(t('document.label.issueDateFromStock'));
              break;
              case "ISS-SO":                
                setAddressRight({...partnerAddress,header: t('partner.label.customer')});                
                setAddressLeft({...companyAddress,header: t('partner.label.supplier')});
                setActionDate(t('document.label.issueDateFromStock'));
              break;
              case "ISS-UNP":                         
                setAddressRight({...companyAddress,header: t('partner.label.supplier')});
                setAddressLeft({...companyAddress,header: t('partner.label.customer')});
                setActionDate(t('document.label.issueDateFromStock'));
              break;        
              case "RCT-WO":                
                setAddressRight({...companyAddress,header: t('partner.label.supplier')});                
                setAddressLeft({...companyAddress,header: t('partner.label.customer')});
                setActionDate(t('document.label.receiveDateToStock'));
              break;
              case "RCT-PO":                
                setAddressRight({...companyAddress,header: t('partner.label.customer')});   
                //console.log(partnerAddress.companyName)             
                setAddressLeft({...partnerAddress,header: t('partner.label.supplier')});
                setActionDate(t('document.label.receiveDateToStock'));
              break;     
              case "ISS-TR":
                setAddressRight({...companyAddress,header: t('partner.label.customer')});   
                //console.log(partnerAddress.companyName)             
                setAddressLeft({...partnerAddress,header: t('partner.label.supplier')});
                setActionDate(t('document.label.moveDateToStock'));
              break;    
              case "RCT-TR":
                setAddressRight({...companyAddress,header: t('partner.label.customer')});   
                //console.log(partnerAddress.companyName)             
                setAddressLeft({...partnerAddress,header: t('partner.label.supplier')});
                setActionDate(t('document.label.moveDateFromStock'));
              break; 
              default:
           
            }
       
          }, [companyAddress,partnerAddress])


        return(
            <Document>
                <Page size="A4" style={styles.page}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' , marginTop: '40px'}}><img src={logo}  style={styles.logo}  /></div>
                   
                    <View style={{textAlign: 'left', marginLeft: '40px', fontSize: 25, fontWeight: 'bold'}}>{documentTitle}<span style={{float: 'right', marginRight: '40px'}}>{document!=null && document.documentText1!=null ? document.documentText1 : ''}</span></View>                                        
                    <View style={styles.viewBox} />
                    <View style={{marginTop: '10px'}} />
                    <View style={styles.viewBox}>
                        <div style={{width: '50%', display: 'inline-block'}}>
                        {addressLeft ?
                                        <CompanyAddress adr={addressLeft}/>
                                        :
                                        <></>
                        }    
                        </div>
                        <div style={{width: '50%', display: 'inline-block', fontSize: 20, }}>
                            <table style={{width: '100%'}}>
                                <tr>
                                    <td>{t('document.label.documentNumber')}:</td>
                                    <td style={{textAlign: 'right', marginRight: '5px'}}>{document ? document.documentText1 : ''}</td>
                                </tr>
                                { document && document.invoiceNbr ?
                                <tr>
                                    <td>{t('document.label.invoiceNumber')}:</td>
                                    <td style={{textAlign: 'right', marginRight: '5px'}}>{document ? document.invoiceNbr : ''}</td>
                                </tr>
                                :
                                <></>
                                }                               
                                { warehouseIss && warehouseIss.id!=null ?
                                <tr>
                                    <td>{t('warehouse.label.warehouseIss')}:</td>
                                    <td style={{textAlign: 'right', marginRight: '5px'}}>{warehouseIss.name+" ["+warehouseIss.number+"]"}</td>
                                </tr>
                                :
                                <></>
                                }
                                { warehouseRct && warehouseRct.id!=null ?
                                <tr>
                                    <td>{t('warehouse.label.warehouseRct')}:</td>
                                    <td style={{textAlign: 'right', marginRight: '5px'}}>{warehouseRct.name+" ["+warehouseRct.number+"]"}</td>
                                </tr>
                                :
                                <></>
                                }
                                 { document && document.workOrderNbr ?
                                <tr>
                                    <td>{t('workOrder.label.workOrderNbr')}:</td>
                                    <td style={{textAlign: 'right', marginRight: '5px'}}>{document ? document.workOrderNbr : ''}</td>
                                </tr>
                                :
                                <></>
                                }
                            </table>     
                            <View style={styles.viewBox2} >
                                    {addressRight ?
                                        <CompanyAddress adr={addressRight}/>
                                        :
                                        <></>
                                    }
                                   
                            </View> 
                                               
                        </div>
                    </View>       
                    <View style={styles.viewBox}>
                      <div style={{textAlign: 'left', marginLeft: '5px'}}> {actionDate}: { moment(document ? document.documentDate2 : null, "x").format("DD.MM.YYYY")}</div>                                                              
                    </View>                                                                         
                    <View style={styles.viewBox}>
                      <div style={{textAlign: 'left', marginLeft: '5px'}}> {document && document.documentDescription1 ? document.documentDescription1 : null}</div>                                                              
                    </View>
                    <DocumentItemsTable
                        document={document}
                    />
                    {/*
                    <InvoiceNo invoice={invoice}/>
                    <BillTo invoice={invoice}/>
                    <InvoiceItemsTable invoice={invoice} />
                    <InvoiceThankYouMsg />
  */}
                </Page>
            </Document>
        )};
  
  export default DocumentPrintTemplate1